import { logout } from "../components/user/services/Authentication";
import { safeParse } from "../helper/helper";
import { setTenantConfig } from "../redux/slices/tenantConfigSlice";
import { clearUser } from "../redux/slices/userSlice";
import { clearMenus } from "../redux/slices/menusSlice";
import { setLoading } from "../redux/slices/loadingSlice";

export const createLogoutHandler = (dispatch, setState) => {
  return async (logoutReason = null) => {
    dispatch(setLoading(true));
    await logout(logoutReason);
    const AWSCode = safeParse(sessionStorage.getItem("AWSCode"));
    const tenantConfig = safeParse(sessionStorage.getItem("tenantConfig"));

    sessionStorage.clear();

    if (tenantConfig) {
      sessionStorage.setItem("tenantConfig", JSON.stringify(tenantConfig));
      dispatch(setTenantConfig({ config: tenantConfig, hosttoken: undefined }));
    }

    dispatch(clearUser());
    dispatch(clearMenus());

    setState((prev) => ({
      ...prev,
      user: null,
      menus: null,
      hosttoken: undefined,
      loggedIn: null,
      contractSummary: null,
      isSFTicketHolded: false,
      openCreateTicketBox: false,
      awsLogoutLoading: !!(tenantConfig?.logoutUrl && AWSCode),
    }));
    dispatch(setLoading(false));
  };
};
